import { propEq } from 'ramda'
import { D4SIGN_WIDGET } from '../../_services/d4sign/_widget'

import { GOOGLE_CALENDAR_WIDGET } from '../../_services/google/widget'
import { SLACK_WIDGET } from '../../_services/slack/_widget'
import { TWILIO_WIDGET } from '../../_services/twilio/_widget'
import { CHAT_PRO_WIDGET } from '../../_services/chat_pro/_widget'
import { SEGWARE_WIDGET } from '../../_services/segware/_widget'

export const WIDGET_CONFIGS = [
  SLACK_WIDGET,
  //GOOGLE_CALENDAR_WIDGET,
  TWILIO_WIDGET,
  CHAT_PRO_WIDGET,
  D4SIGN_WIDGET,
  SEGWARE_WIDGET
]

export const getWiget = type => WIDGET_CONFIGS.find(propEq('id', type))
